import { KeyboardArrowLeft, KeyboardArrowRight } from '@mui/icons-material';
import { Box, Button, MobileStepper, useTheme } from '@mui/material';
import React, { useEffect } from 'react';
import WarningMessage from '../../shared/components/WarningMessage/WarningMessage';
import { steps } from '../constants/steps';
import { useStepperContext } from '../context/StepperContext';
import { StatefulButton } from './StatefulButton';
import ScrollToTopBox from '../../shared/components/ScrollToTopBox/ScrollToTopBox';
import ProfileEditPanel from './ProfileEditPanel/ProfileEditPanel';
import { useLoginContext } from '../../../../contexts/LoginContext';
import { isProfileNameValid } from '../../util';

export const MyMobileStepper: React.FC = () => {
  const {
    activeStep,
    handleNext,
    handleBack,
    isLastStep,
    warningMessage,
    showWarning,
    isNewProfile,
  } = useStepperContext();

  const { user, selectedProfileIndex } = useLoginContext();

  const maxSteps = steps.length;
  const theme = useTheme();

  useEffect(() => {
    window.scrollTo(0, 0); // Scrolls to the top-left of the window
  }, [activeStep]);

  const shouldShowStepper =
    user.extProfiles.length > 0 &&
    typeof selectedProfileIndex === 'number' &&
    user.extProfiles[selectedProfileIndex].name !== '' &&
    (isNewProfile
      ? isProfileNameValid(
          user.extProfiles[selectedProfileIndex].name,
          user,
          selectedProfileIndex
        )
      : true);

  return (
    <Box
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      {/* Fixed header with ProfileSelector */}
      <Box
        sx={{
          p: 2,
          borderBottom: '1px solid',
          borderColor: 'divider',
          flex: '0 0 auto',
        }}
      >
        <ProfileEditPanel />
      </Box>
      {/* Center scrollable content */}
      {shouldShowStepper && (
        <>
          <Box
            sx={{
              flex: 1,
              minHeight: 0,
              overflowY: 'auto',
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <ScrollToTopBox sx={{ p: 2, flex: 1 }}>
              {steps[activeStep].component &&
                React.createElement(steps[activeStep].component, {
                  label: steps[activeStep].label,
                  description: steps[activeStep].description,
                  stepIndex: activeStep,
                })}
            </ScrollToTopBox>
          </Box>
          <Box>
            <WarningMessage message={warningMessage} show={showWarning} />
            <MobileStepper
              sx={{
                borderColor: theme.palette.divider,
                borderTop: '1px solid',
                m: 1,
              }}
              variant="dots"
              steps={maxSteps}
              position="static"
              activeStep={activeStep}
              nextButton={
                <StatefulButton
                  size="small"
                  onClick={handleNext}
                  allowNavigation={true}
                  disabled={isLastStep()}
                >
                  Next
                  {theme.direction === 'rtl' ? (
                    <KeyboardArrowLeft />
                  ) : (
                    <KeyboardArrowRight />
                  )}
                </StatefulButton>
              }
              backButton={
                <Button
                  size="small"
                  onClick={handleBack}
                  disabled={activeStep === 0}
                >
                  {theme.direction === 'rtl' ? (
                    <KeyboardArrowRight />
                  ) : (
                    <KeyboardArrowLeft />
                  )}
                  Back
                </Button>
              }
            />
          </Box>
        </>
      )}
    </Box>
  );
};
